import { render, staticRenderFns } from "./PaymentSettingsB2b.vue?vue&type=template&id=104cb854"
import script from "./PaymentSettingsB2b.vue?vue&type=script&lang=js"
export * from "./PaymentSettingsB2b.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports